export const JOINED_COUNT = '50 000';

export const AB_TEST_SIGNUP_EMAIL_VERIFICATION = 'signup_email_verification';
export const AB_TEST_VARIANT_WITHOUT = 'without_verification';
export const AB_TEST_VARIANT_WITH = 'with_verification';
